module.exports = __webpack_public_path__ + "img/1745566970_mvZe.c9c7d369.png";